import {
  UPDATE_CONNECTOR_COUNT_VALUE,
  UPDATE_CONNECTOR_TYPE_VALUE,
  ADD_CONNECTOR,
  REMOVE_CONNECTOR,
} from './constants'

export const updateConnectorCount = (index, connectorCount) => {
  return {
    type: UPDATE_CONNECTOR_COUNT_VALUE,
    connectorCount,
    index
  }
}

export const updateConnectorValue = (index, pinCount) => {
  return {
    type: UPDATE_CONNECTOR_TYPE_VALUE,
    pinCount,
    index
  }
}

export const addConnector = () => {
  return {
    type: ADD_CONNECTOR
  }
}

export const removeConnector = (index) => {
  return {
    type: REMOVE_CONNECTOR,
    index
  }
}
